import React from 'react';

import DocumentIcon from '@atlaskit/icon/core/file';
import EditorNumberListIcon from '@atlaskit/icon/core/list-numbered';
import SubtaskIcon from '@atlaskit/icon/core/subtasks';
import EditorDecisionIcon from '@atlaskit/icon/core/decision';
import RoadmapIcon from '@atlaskit/icon/core/roadmap';
import TeamsIcon from '@atlaskit/icon/core/teams';
import FolderIcon from '@atlaskit/icon/core/folder-closed';
import { token } from '@atlaskit/tokens';

import { BPQA_TOP_TEMPLATE_KEYS } from './bpqaConst.ts';

const getTemplateIcon = (blueprintModuleCompleteKey: string | null): JSX.Element => {
	const dataTestId = `${blueprintModuleCompleteKey}-icon`;

	switch (blueprintModuleCompleteKey) {
		case BPQA_TOP_TEMPLATE_KEYS.HOW_TO_ARTICLE:
		case BPQA_TOP_TEMPLATE_KEYS.PRODUCT_REQUIREMENTS:
			return (
				<EditorNumberListIcon
					spacing="spacious"
					label=""
					color={token('color.icon.subtle')}
					testId={dataTestId}
				/>
			);
		case BPQA_TOP_TEMPLATE_KEYS.PROJECT_PLAN:
			return (
				<SubtaskIcon
					label=""
					color={token('color.icon.subtle')}
					testId={dataTestId}
					spacing="spacious"
				/>
			);
		case BPQA_TOP_TEMPLATE_KEYS.RETROSPECTIVE:
		case BPQA_TOP_TEMPLATE_KEYS.DECISIONS:
			return (
				<EditorDecisionIcon
					spacing="spacious"
					label=""
					color={token('color.icon.subtle')}
					testId={dataTestId}
				/>
			);
		case BPQA_TOP_TEMPLATE_KEYS.PRODUCT_ROADMAP:
			return (
				<RoadmapIcon
					label=""
					color={token('color.icon.subtle')}
					testId={dataTestId}
					spacing="spacious"
				/>
			);
		case BPQA_TOP_TEMPLATE_KEYS.WEEKLY_MEETING_NOTES:
			return (
				<TeamsIcon
					label=""
					color={token('color.icon.subtle')}
					testId={dataTestId}
					spacing="spacious"
				/>
			);
		case BPQA_TOP_TEMPLATE_KEYS.FILE_LIST:
			return (
				<FolderIcon
					label=""
					color={token('color.icon.subtle')}
					testId={dataTestId}
					spacing="spacious"
				/>
			);
		default:
			return (
				<DocumentIcon
					spacing="spacious"
					label=""
					color={token('color.icon.subtle')}
					testId="default-template-icon"
				/>
			);
	}
};

export type TemplateIconProps = {
	blueprintModuleCompleteKey: string | null;
};

export const QuickTemplateIcon = ({ blueprintModuleCompleteKey }: TemplateIconProps) => {
	return getTemplateIcon(blueprintModuleCompleteKey);
};
